/* eslint-disable react/no-array-index-key */
import NavbarCompany from '@deprecated-ui/company/Navbar';
import color from '@deprecated-ui/_style/color';
import { useRouter } from 'next/router';
import DATA_CY from 'constants/data-cy';
import { selectors as profileSelectors } from 'lib/entities/profile';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { AnalystTooltip, NavbarWrapper, NavLink, TooltipLink } from './styled';
import { ITabItems } from '../../../../@types/company.d';
import { TAB_LIST, TAB_LIST_NAME } from '../constants';

const { NavBarComponent, NavMoreLogo } = NavbarCompany;

interface NavbarProps {
  active: string;
  tabs: Array<ITabItems>;
  isCompanyStock?: boolean;
  className?: string;
  isLoggedIn?: boolean;
  userId?: string;
  onClickTab?: (...args) => void;
  onSendClevertapEvent?: (...args) => void;
}

const PATH_ANALYST = TAB_LIST[TAB_LIST_NAME.ANALYST].path;
const TOOLTIP_ANALYST_TEXT = 'Kompilasi target analyst dari berbagai sekuritas';

function Navbar({
  active,
  tabs,
  isCompanyStock = false,
  className,
  isLoggedIn = false,
  userId = '',
  onClickTab,
  onSendClevertapEvent = () => {},
}: NavbarProps) {
  const router = useRouter();
  const { symbol } = router.query;
  const [isShowingAnalystTooltip, setIsShowingAnalystTooltip] =
    useState<boolean>(false);
  const { data: profileData } = useSelector(profileSelectors);
  const { country: profileCountry = 'ID' } = profileData;
  const returnNotLogin = () => {
    if (isCompanyStock) {
      onClickTab(true);
    } else {
      router.push('/register');
    }
  };

  const onSelectTab = (event, { path }: Pick<ITabItems, 'path'>) => {
    event.preventDefault();
    itemNavigationOnClick(getPathName(path));
    if (isLoggedIn) {
      router.push(`/symbol/${symbol}${path}`, undefined, { scroll: false });
    } else {
      returnNotLogin();
    }
  };

  const getPathName = (path: string): string => {
    try {
      return path.slice(1);
    } catch (_error) {
      return path;
    }
  };

  const checkIsActive = (value: string): boolean => {
    // Make stream active if path is /buy and value is empty
    if (active === TAB_LIST_NAME.BUY && value === '') return true;

    return active === getPathName(value);
  };

  const getAnalystUserIds = (): Array<string> => {
    const analystUserIds: string = localStorage.getItem('analystUserIds');
    let analystUserIdsArray: Array<string> = [];
    if (analystUserIds) {
      analystUserIdsArray = analystUserIds.split(',');
    }
    return analystUserIdsArray;
  };

  const setAnalystUserIds = (analystUserIds: Array<string>) => {
    const newAnalystUserIds: Array<string> = [...analystUserIds];
    newAnalystUserIds.push(String(userId));
    localStorage.setItem('analystUserIds', newAnalystUserIds.join());
  };

  const isUserIdExistsInAnalystUserIds = (
    analystUserIds: Array<string>,
  ): boolean => analystUserIds.includes(String(userId));

  const onCloseAnalystTooltip = () => {
    // Update analystUserIds
    const analystUserIds: Array<string> = getAnalystUserIds();
    if (!isUserIdExistsInAnalystUserIds(analystUserIds)) {
      setAnalystUserIds(analystUserIds);
    }

    // Hide Analyst Tooltip
    setIsShowingAnalystTooltip(false);
  };

  const itemNavigationOnClick = (itemName: string) => {
    if (itemName === TAB_LIST_NAME.ANALYST) {
      onCloseAnalystTooltip();
    }

    // need to set timeout for sending clevertap event due to
    // RaceCondition issue between Http Request & Switching Page route
    onSendClevertapEvent({ tabPath: itemName, timeout: 500 });
  };

  const isLoggedInAndHaveUserId: boolean = isLoggedIn && !!userId;

  const shouldShowAnalystTooltip = (analystUserIds: Array<string>): boolean =>
    isLoggedInAndHaveUserId &&
    !isUserIdExistsInAnalystUserIds(analystUserIds) &&
    !isShowingAnalystTooltip;

  useEffect(() => {
    const analystUserIds = getAnalystUserIds();
    if (shouldShowAnalystTooltip(analystUserIds)) {
      setIsShowingAnalystTooltip(true);
    }
  }, [userId, active]);

  const MoreMenu = () => (
    <div data-cy={DATA_CY.COMPANY.NAVBAR_MORE_MENU}>
      <NavMoreLogo />
    </div>
  );

  return (
    <NavbarWrapper className={className}>
      <NavBarComponent
        className={`navbar-company ${profileCountry.toLowerCase()}`}
        expandNavLogo={MoreMenu}
      >
        {tabs.map((item: ITabItems, index: number) =>
          item.path === PATH_ANALYST ? (
            <AnalystTooltip
              placement="bottom"
              visible={isShowingAnalystTooltip}
              overlayClassName="analyst-tooltip"
              color={color.primary}
              getPopupContainer={(triggerNode) => triggerNode}
              title={() => (
                <Link
                  href={`/symbol/${symbol}${item.path}`}
                  passHref
                  scroll={false}
                >
                  <TooltipLink
                    onClick={() =>
                      itemNavigationOnClick(getPathName(item.path))
                    }
                  >
                    {TOOLTIP_ANALYST_TEXT}
                  </TooltipLink>
                </Link>
              )}
            >
              <Link
                href={`/symbol/${symbol}${item.path}`}
                passHref
                scroll={false}
              >
                <NavLink
                  key={index}
                  onClick={(e) => onSelectTab(e, item)}
                  // @ts-expect-error
                  isActive={checkIsActive(item.path)}
                  data-cy={`company-navigation-${item.label
                    .toLocaleLowerCase()
                    .replace(' ', '-')}`}
                >
                  {item.label}
                </NavLink>
              </Link>
            </AnalystTooltip>
          ) : (
            <Link
              href={`/symbol/${symbol}${item.path}`}
              passHref
              scroll={false}
            >
              <NavLink
                key={index}
                onClick={(e) => onSelectTab(e, item)}
                // @ts-expect-error
                isActive={checkIsActive(item.path)}
                data-cy={`company-navigation-${item.label
                  .toLocaleLowerCase()
                  .replace(' ', '-')}`}
              >
                {item.label}
              </NavLink>
            </Link>
          ),
        )}
      </NavBarComponent>
    </NavbarWrapper>
  );
}

export default Navbar;
